<div [class.open]="results.length" class="select_list">
    <div [class.selected]="selected" class="search__field">
        <input #input (keyup.arrowDown)="arrowSelector();" (keyup.arrowUp)="arrowSelector()"
               [class.selected]="selected"
               [formControl]="value"
               placeholder="Поиск коллекции"
               type="text">
        <i (click)="remove()" *ngIf="selected" class="icon-close"></i>
    </div>
    <div #search_hints class="search__hints list">
        <label (click)="select(item)" *ngFor="let item of results; let i = index">
            <input name="select_map" type="radio" value="{{item.id}}">
            <span>{{ item.name }}</span>
        </label>
    </div>
</div>
